var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhPeople1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1136_5447",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1136_5447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.32682 21.3999H19.3605C19.8791 18.0463 17.9382 14.5257 14.8894 13.2873C14.628 13.195 14.3436 13.195 14.0823 13.2873C12.6417 13.845 11.0492 13.845 9.60869 13.2873C9.34735 13.195 9.06295 13.195 8.80161 13.2873C5.75033 14.5295 3.81188 18.0413 4.32682 21.3999ZM11.8244 12.5726C12.7923 12.5736 13.7387 12.2837 14.5443 11.7395C15.35 11.1952 15.9787 10.4211 16.3513 9.51469C16.7238 8.6083 16.8233 7.61026 16.6374 6.64649C16.4516 5.68272 15.9885 4.79641 15.3068 4.09938C14.625 3.40234 13.755 2.92582 12.8066 2.72992C11.8582 2.53402 10.8739 2.62753 9.97781 2.99864C9.08173 3.36976 8.31405 4.00185 7.77163 4.81518C7.22921 5.62851 6.93634 6.58662 6.92998 7.56865C6.89284 10.303 9.1024 12.5613 11.8244 12.5726Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32682 21.4C3.81188 18.0414 5.75033 14.5296 8.80161 13.2861C9.06295 13.1939 9.34735 13.1939 9.60869 13.2861C11.0492 13.8438 12.6417 13.8438 14.0823 13.2861C14.3436 13.1939 14.628 13.1939 14.8894 13.2861C17.9382 14.5246 19.8791 18.0452 19.3605 21.3987L4.32682 21.4Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8246 12.5727C9.10133 12.5614 6.89301 10.3031 6.93015 7.56999C6.93334 6.58363 7.22477 5.62038 7.76757 4.8021C8.31036 3.98381 9.08016 3.34726 9.97955 2.97296C10.8789 2.59865 11.8675 2.50341 12.8202 2.69928C13.773 2.89516 14.6471 3.37335 15.332 4.07336C16.0168 4.77338 16.4817 5.66377 16.6678 6.6319C16.8538 7.60003 16.7527 8.60241 16.3773 9.51224C16.0018 10.4221 15.3689 11.1985 14.5585 11.7432C13.7481 12.288 12.7967 12.5767 11.8246 12.5727Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhPeople1);
export default __webpack_public_path__ + "static/media/wh_people1.06cf539f1b4227a73b118b0feb6702a6.svg";
export { ForwardRef as ReactComponent };